<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button class="btnback btn btn-outline-success" type="button" (click)="onBack()" title="Volver"><i class="fa fa-chevron-left"></i></button>
        <button *ngIf="!visibilitySpinner" [disabled]="formInvalid" type="button" class="btn btn-outline-success" (click)="onSave()" title="Guardar"><i class="fa fa-save"></i> Guardar</button>
        <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Guardando
        </button>
        <div *ngIf="(plazoPeriodo || (datosPeriodo && IdPeriodo)) && esPeriodoPlazoFinalizado" class="ms-1 nota-info">
            <label class="col-form-label" for=""><i class="fa fa-info-circle" aria-hidden="true"></i> Plazo del periodo finalizado</label>
        </div>
        <ng-container *ngIf="plazoPeriodo && esPeriodoPlazoIniciado && !esPeriodoPlazoFinalizado">
            <div *ngIf="esVigenteConSolicitudes" class="nota-info">
                <label class="col-form-label" for=""><i class="fa fa-info-circle" aria-hidden="true"></i> Algunos datos del plazo no se pueden modificar: Plazo iniciado</label>
            </div>
        </ng-container>
    </form>
</nav>

<app-plazos-edit [plazoPeriodo]="plazoPeriodo" [datosPeriodo]="datosPeriodo" [fechaParcelaOblig]="fechaParcelaOblig" [fechaConfeccionOblig]="fechaConfeccionOblig"
                 [fechaInvernaderoOblig]="fechaInvernaderoOblig" [fechaEmpDeshidratadoraOblig]="fechaEmpDeshidratadoraOblig" [formGroup]="form"
                 (changeHabilitarExportacion)="onChangeHabilitarExportacion()"></app-plazos-edit>
